export default __webpack_public_path__ + "static/media/up.899974e5.svg";